import { AgCartesianAxisOptions, AgChartOptions } from 'ag-charts-community'

export const sharedOptions: AgChartOptions = {
  zoom: {
    enabled: true,
    enablePanning: true,
    axes: 'xy',
    anchorPointX: 'pointer',
    anchorPointY: 'pointer',
  },
  sync: {
    enabled: true,
    axes: 'x',
    nodeInteraction: true,
  },
  navigator: {
    enabled: true,
  },
  height: 400,
}

export const timeAxis: AgCartesianAxisOptions = {
  type: 'unit-time',
  position: 'bottom',
  parentLevel: {
    enabled: true,
  },
  keys: ['date'],
  crosshair: {
    enabled: true,
  },
}
